// extracted by mini-css-extract-plugin
export default {"baggagePolicies":"SearchBaggagePolicies-module__baggagePolicies___lYU7C","modalOpener":"SearchBaggagePolicies-module__modalOpener___sQt1_"};